import { checkCategoryAvailability } from './daypartMenuAvailability';

//change the category availability checking. an item maybe in different category
// This as of right now is only bering used for getting available upsells
const itemCategoryAvailibilityValidate = ({
  id,
  subMenus,
  categoriesInfo,
  dateTimeSelected,
  daypartSlots = {},
}: {
  id?: string;
  subMenus?: MenuNode[];
  categoriesInfo: CategoryInfo[];
  dateTimeSelected?: string;
  daypartSlots?: DaypartMap;
}): boolean => {
  const categoriesByItem = [] as string[];

  if (!id || !subMenus || subMenus.length === 0) return true;

  subMenus.forEach(cat => {
    if (cat.items.includes(id)) {
      categoriesByItem.push(cat.id);
    }
    if (cat.subMenus && cat.subMenus.length > 0) {
      cat.subMenus.forEach(sub => {
        if (sub.items.includes(id)) {
          categoriesByItem.push(sub.id);
          categoriesByItem.push(cat.id);
        }
      });
    }
  });

  const categoriesArr = Array.from(new Set(categoriesByItem));

  // Items not in any category (e.g. upsell-only items) have no category restriction
  if (categoriesArr.length === 0) return true;

  return categoriesArr.some(current => {
    const cat = categoriesInfo.find(c => c.id === current);
    const [_catAvailability] = checkCategoryAvailability({
      category: cat,
      dateTimeSelected,
      daypartSlots,
    });
    return _catAvailability;
  });
};
export default itemCategoryAvailibilityValidate;
